import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { NameSchema } from '../property.models.ts'

export const BillingAddressIdSchema = z.string().brand('billing-address-id')
export type BillingAddressId = ZodInfer<typeof BillingAddressIdSchema>

export const BillingAddressId = (value: string = generateRandomString(16)) => {
  return BillingAddressIdSchema.parse(value)
}

export const AddressLineSchema = z.string()
export const CitySchema = z.string()
export const StateSchema = z.string()
export const ZipSchema = z.string()

export const BillingAddressDomainSelectModelSchema = z.object({
  billingAddressId: BillingAddressIdSchema,
  name: NameSchema,
  address1: AddressLineSchema,
  address2: AddressLineSchema.optional(),
  city: CitySchema,
  state: StateSchema,
  zip: ZipSchema,
})

export type BillingAddressDomainSelectModel = ZodInfer<
  typeof BillingAddressDomainSelectModelSchema
>

export const BillingAddressDomainInsertModelSchema =
  BillingAddressDomainSelectModelSchema.omit({
    billingAddressId: true,
  })

export type BillingAddressDomainInsertModel = ZodInfer<
  typeof BillingAddressDomainInsertModelSchema
>

export const BillingAddressDomainUpdateModelSchema =
  BillingAddressDomainSelectModelSchema
